<template>
  <div class="dashboard-container">
    <!-- 添加顶部用户信息区域 -->
    <div class="header-user-info">
      <el-button class="help-button" type="primary" link @click="showHelp">
        <el-icon>
          <QuestionFilled />
        </el-icon>
        帮助
      </el-button>
    </div>

    <!-- 时间筛选区域 -->
    <div class="filter-section">
      <el-row>
        <el-col :span="5">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :shortcuts="dateShortcuts"
            @change="handleDateChange"
          />
        </el-col>
        <el-col :span="3">
          <el-input
              clearable
            v-model="SearchMaterialNumber"
            placeholder="请输入物料编码(SKU)"
          />
        </el-col>
        <el-col :span="3">
          <el-input clearable v-model="SearchSaler" placeholder="请输入销售人" />
        </el-col>
        <el-col :span="3">
          <el-input clearable v-model="SearchBillNo" placeholder="请输入单据编号" />
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="getOrderData">查询</el-button>
        </el-col>
        <el-col :span="3">
          <el-button @click="openProductSearch">产品查询</el-button>
          <el-button @click="openProduceView">生产计划查看</el-button>
          <!-- 添加导出按钮 -->
        </el-col>
      </el-row>
    </div>
    <!-- 统计卡片区域 -->
    <div class="stats-cards">
      <el-row :gutter="20">
        <el-col :span="4" v-for="(item, index) in statsData" :key="index">
          <el-card
            class="stats-card"
            :class="{ 'is-active': activeCard === item.notice_code }"
            @click="handleCardClick(item)"
          >
            <div class="card-content">
              <p class="number">{{ item.count }}</p>
              <p class="item-title">{{ item.title }}</p>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- <p>{{ selectName }}的销售订单</p> -->
    <!-- 订单列表区域 -->
    <div class="order-list">
      <!-- 批量操作工具栏 -->
      <el-table
        :max-height="tableHeight"
        :data="orders"
        style="width: 100%"
        @sort-change="handleSortChange"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="30" />
        <el-table-column prop="BillNo" label="销售编码" min-width="70">
          <template #default="scope">
            {{ scope.row.BillNo }}
          </template>
        </el-table-column>
        <el-table-column
          label="进度"
          min-width="90"
          align="center"
          sortable="custom"
          prop="Progress"
        >
          <template #default="scope">
            <el-tag :type="getProgressType(scope.row.Progress)"
              >{{ scope.row.Progress || 0 }}%</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="Summary"
          label="备注"
          min-width="150"
          show-overflow-tooltip
          align="left"
          :formatter="(row) => calculateSummary(row.Stages)"
        />
        <el-table-column
          prop="MaterialName"
          label="成品名称"
          min-width="150"
          align="left"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="MaterialNumber"
          label="物料编码"
          min-width="135"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="Qty"
          label="下单数量"
          min-width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="StockInQuaAuxQty"
          label="累计入库"
          min-width="90"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
            prop="StockOutQty"
            label="累计出库"
            min-width="90"
            align="center"
            sortable="custom"
        ></el-table-column>
        <el-table-column
          label="要货时间"
          sortable="custom"
          min-width="100"
          prop="DeliveryDate"
          :formatter="formatDate"
          align="left"
        >
        </el-table-column>
        <el-table-column
          label="排产开始"
          sortable="custom"
          min-width="100"
          :formatter="formatDate"
          prop="PlanStartDate"
          align="left"
        >
        </el-table-column>
        <el-table-column
            label="下达时间"
            sortable="custom"
            min-width="100"
            :formatter="formatDate"
            prop="ConveyDate"
            align="left"
        >
        </el-table-column>
        <el-table-column
            label="完工时间"
            sortable="custom"
            min-width="100"
            :formatter="formatDate"
            prop="FinishDate"
            align="left"
        >
        </el-table-column>
        <el-table-column
          prop="Saler"
          label="销售人"
          min-width="70"
          align="left"
        />
        <el-table-column
          label="下单时间"
          sortable="custom"
          min-width="100"
          :formatter="formatDate"
          prop="BillCreateTime"
          align="left"
        >
        </el-table-column>
        <el-table-column
            v-if="activeCard !=13"
          label="距离交货"
          min-width="90"
          align="left"
          sortable="custom"
          prop="DeliveryDate"
        >
          <template #default="scope">
            <el-tag :type="getDeliveryDelayType(scope.row.DeliveryDate)"
              >{{ getDiffDay(scope.row.DeliveryDate) }}天</el-tag
            >
            <!-- <span>{{ getDiffDay(scope.row.PlanEndDate) }}天</span> -->
          </template>
        </el-table-column>
        <el-table-column
            v-else
            label="距离清尾超期"
            min-width="90"
            align="left"
            sortable="custom"
            prop="PlanEndDate"
        >
          <template #default="scope">
            <el-tag :type="getDeliveryDelayType(scope.row.ConveyDate,15)"
            >{{ getDiffDay(scope.row.ConveyDate,15) }}天</el-tag
            >
            <!-- <span>{{ getDiffDay(scope.row.PlanEndDate) }}天</span> -->
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="120" align="center">
          <template #default="scope">
            <div class="order-actions">
              <!-- <el-tag
                :type="scope.row.IsFav ? 'danger' : 'primary'"
                @click="toggleFavorite(scope.row)"
              >
                {{ scope.row.IsFav ? "取消关注" : "关注" }}
              </el-tag> -->
              <el-tag type="primary" @click="showOrderDetail(scope.row)"
                >跟进记录</el-tag
              >
              <el-tag type="primary" @click="showPODetail(scope.row)"
                >物料</el-tag
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-container">
        <div >
          <el-button type="danger" @click="handleBatchDelete">
            删除选中项 ({{ selectedOrders.length }})
          </el-button>
          <el-button @click="exportToExcel">全部导出</el-button>
        </div>

        <el-pagination
          class="middle-container"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          :page-sizes="[10, 20, 30, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 添加跟进记录 -->
    <el-dialog
      v-model="dialogVisible"
      :title="`跟进记录(${currentBillNo})`"
      width="50%"
      class="no-padding"
    >
      <div
        class="order-detail"
        style="padding: 0 !important"
        v-if="currentOrder"
      >
        <el-table  :data="currentOrder" class="no-padding">
          <el-table-column prop="StageName" label="阶段名称" width="100" />
          <el-table-column label="状态" width="120">
            <template #default="scope">
              <template v-if="scope.row.isEditing">
                <el-select
                  v-model="scope.row.Status"
                  size="small"
                  v-if="scope.row.StageId === 1"
                >
                  <el-option label="齐料" value="齐料" />
                  <el-option label="待确认" value="待确认" />
                </el-select>
                <!-- <el-select
                  v-model="scope.row.Status"
                  size="small"
                  v-if="scope.row.StageId === 2"
                >
                  <el-option label="未领料" value="未领料" />
                  <el-option label="全部领料" value="全部领料" />
                </el-select>
                <el-select
                  v-model="scope.row.Status"
                  size="small"
                  v-if="scope.row.StageId === 3"
                >
                  <el-option label="全部领料" value="全部领料" />
                  <el-option label="部分领料" value="部分领料" />
                  <el-option label="未领料" value="未领料" />
                </el-select> -->
                <el-select
                  v-model="scope.row.Status"
                  size="small"
                  v-if="scope.row.StageId === 4"
                >
                  <el-option label="待确认" value="待确认" />
                  <el-option label="已确认" value="已确认" />
                </el-select>
                <el-select
                  v-model="scope.row.Status"
                  size="small"
                  v-if="scope.row.StageId === 5"
                >
                  <el-option label="待确认" value="待确认" />
                  <el-option label="已确认" value="已确认" />
                </el-select>
                <el-select
                  v-model="scope.row.Status"
                  size="small"
                  v-if="scope.row.StageId === 6"
                >
                  <el-option label="完工" value="完工" />
                  <el-option label="未排产" value="未排产" />
                  <el-option label="计划" value="计划" />
                  <el-option label="计划确认" value="计划确认" />
                  <el-option label="下达" value="下达" />
                  <el-option label="开工" value="开工" />
                </el-select>
              </template>
              <template v-else>
                <el-tag :type="getMainStatusType(scope.row.Status)">
                  {{ scope.row.Status }}
                </el-tag>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="计划完成时间" width="130">
            <template #default="scope">
              <template v-if="scope.row.isEditing">
                <el-date-picker
                  v-model="scope.row.PlanDate"
                  type="date"
                  size="small"
                  value-format="YYYY-MM-DD"
                  placeholder="选择日期"
                />
              </template>
              <template v-else>
                {{ scope.row.PlanDate }}
              </template>
            </template>
          </el-table-column>
          <el-table-column label="跟进记录" width="220" show-overflow-tooltip>
            <template #default="scope">
              <template v-if="scope.row.isEditing">
                <el-input
                  v-model="scope.row.Summary"
                  type="textarea"
                  size="small"
                  :rows="2"
                />
              </template>
              <template v-else>
                <span>{{ scope.row.Summary }}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="scope">
              <template v-if="scope.row.isEditing">
                <el-button
                  type="success"
                  size="small"
                  @click="handleSave(scope.row)"
                  >保存</el-button
                >
                <el-button size="small" @click="handleCancel(scope.row)"
                  >取消</el-button
                >
              </template>
              <template v-else>
                <el-button
                  type="primary"
                  size="small"
                  @click="handleEdit(scope.row)"
                  >编辑</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-drawer
      v-model="dialogPOVisible"
      :title="`物料详情(${currentBillNo})`"
      size="50%"
      class="no-padding"
    >
      <template v-if="currentPOOrder">
        <div class="order-detail">
          <el-table
            :data="currentPOOrder"
            class="no-padding"
            :row-class-name="tableRowClassName"
            :default-sort="{ prop: 'Diff', order: 'descending' }"
          >
            <el-table-column
              prop="MaterialNumber"
              label="物料编号"
              width="140"
            />
            <el-table-column
              prop="MaterialName"
              label="物料名称"
              width="120"
              show-overflow-tooltip
            />
            <el-table-column
              prop="OrderQty"
              label="订单数量"
              width="80"
              align="center"
            />
            <el-table-column
              prop="PurchaseQty"
              label="采购数量"
              width="80"
              align="center"
            />
            <el-table-column
              prop="StockInQty"
              label="入库数量"
              width="80"
              align="center"
            />
            <el-table-column
              prop="BaseQty"
              label="当前库存"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="Diff"
              label="缺料"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="DeliveryDate"
              label="交货时间"
              width="110"
            ></el-table-column>
            <el-table-column
              prop="UpdateTime"
              label="库存时间"
              width="120"
            ></el-table-column>
          </el-table>
        </div>
      </template>
    </el-drawer>

    <!-- 帮助说明抽屉 -->
    <el-drawer
      v-model="helpDrawerVisible"
      title="使用说明"
      direction="rtl"
      size="600px"
    >
      <div class="help-content">
        <ul>
          <li>
            <strong>进度</strong>
            <p>
              采购状态、领料状态、生产状态，美工状态、软件状态，每个状态占20%的进度；当生产工单<span
                style="color: red"
                >开工</span
              >时，进度100%
            </p>
          </li>
          <li>
            <strong>距离交货</strong>
            <p>当前时间 - 要货时间</p>
          </li>
          <li>
            <strong>清尾超期：</strong>
            <p>下达时间后15天即为清尾超期时间</p>
          </li>
          <li>
            <strong>排序</strong>
            <p>
              初始数据已按照排产时间升序排序(点击字段上的&#9650;和&#9660;排序)
            </p>
          </li>
          <li>
            <strong>查询：</strong>
            <p>
              可通过<span style="color: red">下单时间范围</span
              >、物料编码、销售人、单据编号进行筛选查询
            </p>
          </li>
          <li>
            <strong>统计卡片：</strong>
            <p>点击卡片可快速筛选对应状态的订单</p>
          </li>
          <li>
            <strong>批量删除：</strong>
            <p>
              勾选订单后可进行批量删除操作(删除的订单不再显示在看板，金蝶数据不受影响)
            </p>
          </li>
        </ul>

        <ul>
          <li>
            <strong>跟进记录：</strong>
            <p>
              查看和编辑订单各阶段的状态、计划完成时间和跟进记录。<span
                style="color: red"
                >编辑后采购、生产、PMC、软件、美工相关同事会收到企业微信消息通知。</span
              >
              <span style="color: red"
                >编辑生产的跟进记录后，会显示在生产计划的<strong
                  style="color: red"
                  >生产备注</strong
                ></span
              >
            </p>
          </li>
          <li>
            <strong>物料：</strong>
            <p>查看订单相关的物料清单</p>
          </li>
        </ul>

        <h3>其他功能</h3>
        <ul>
          <li>
            <strong>产品查询：</strong>
            <p>
              跳转到产品查询页面，查询某个产品下过哪些订单(包括已关闭的订单)
            </p>
          </li>
          <li>
            <strong>生产计划查看：</strong>
            <p>跳转到生产计划查看页面</p>
          </li>
        </ul>
      </div>
    </el-drawer>

  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import dayjs from "dayjs";
import { ElMessage, ElMessageBox,ElTable,ElTableColumn,ElDrawer,ElButton,ElInput,ElRow,ElCol,ElDatePicker,ElIcon,ElCard,ElPagination,ElDialog,ElTag} from "element-plus";
import { QuestionFilled } from "@element-plus/icons-vue";
import * as XLSX from "xlsx"; // 修改: import XLSX from "xlsx";
import { useRouter } from 'vue-router';
import http from "/src/utils/requset.js";
import {deleteOrderOrders, getOrderCount, getOrderOrders} from "@/utils/api";
// 获取最近一个月的时间范围
const getLastMonthRange = () => {
  const end = new Date();
  const start = new Date();
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 3);
  return [start, end];
};


// 主表格状态标签颜色处理
const getMainStatusType = (status) => {
  const statusMap = {
    正常: "success",
    完工: "success",
    全部领料: "success",
    已确认: "success",
    齐料: "success",
    缺料: "danger",
    异常: "danger",
  };
  return statusMap[status] || "info";
};

const getProgressType = (progress) => {
  if (progress == 100) {
    return "success";
  } else if (progress > 0) {
    return "danger";
  }
};

const getDeliveryDelayType = (end_date,ext=0) => {
  let delay_day = getDiffDay(end_date,ext);
  if (delay_day > 0) {
    return "success";
  }
  return "danger";
};

// 查询参数
const dateRange = ref(getLastMonthRange());
const SearchMaterialNumber = ref("");
const SearchBillNo = ref("");
const SearchSaler = ref("");
const currentPage = ref(1);
const pageSize = ref(10);
const OrderBy = ref("PlanStartDate");
const tableHeight = ref(500);

// 响应参数
const total = ref(0);

// 日期快捷选项
const dateShortcuts = [
  {
    text: "最近一周",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      return [start, end];
    },
  },
  {
    text: "最近一个月",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return [start, end];
    },
  },
  {
    text: "最近三个月",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 3);
      return [start, end];
    },
  },
];

// 统计数据
const statsData = ref([
  { title: "未关闭", count: 40, notice_code: 11 },
  { title: "采购待确认", count: 10, notice_code: 1 },
  { title: "美工待确认", count: 10, notice_code: 2 },
  { title: "软件待确认", count: 10, notice_code: 3 },
  { title: "生产超期", count: 10, notice_code: 12 },
  { title: "生产清尾", count: 10, notice_code: 13 },
]);

// 模拟订单数据
const orders = ref([]);

const selectID = ref(0);

// 添加新的响应式变量
const dialogVisible = ref(false);
const dialogPOVisible = ref(false);
const currentOrder = ref(null);
const currentPOOrder = ref(null);
const currentBillNo = ref(null);

// 选中的订单
const selectedOrders = ref([]);

// 帮助抽屉控制
const helpDrawerVisible = ref(false);

const router = useRouter();

// 处理日期变化
const handleDateChange = (val) => {
  if (!val) return;
  // 这里添加获取数据的逻辑
  getOrderData();
  // fetchOrderData(val[0], val[1]);
  fetchStatData(val[0], val[1]);
};

// 获取统计信息
const fetchStatData = async (startDate, endDate) => {
  let start_date = dayjs(startDate).format("YYYY-MM-DD");
  let end_date = dayjs(endDate).format("YYYY-MM-DD");
  getOrderCount({start:start_date,end:end_date}).then(res=>{
    statsData.value = res.Data;
  }).catch(err=>{
    console.log(err);
  })

};

const buildParams = () => {
  let start_date = dayjs(dateRange.value[0]).format("YYYY-MM-DD");
  let end_date = dayjs(dateRange.value[1]).format("YYYY-MM-DD");
  let params = {
    StartDate: start_date,
    EndDate: end_date,
    MaterialNumber: SearchMaterialNumber.value,
    BillNo: SearchBillNo.value,
    Saler: SearchSaler.value,
    OrderBy: OrderBy.value,
    PageSize: pageSize.value,
    PageNumber: currentPage.value,
    CloseStatus: "正常",
  };

  params["NoticeCode"] = activeCard.value;
  return params;
};
// 获取订单方法
const getOrderData = async () => {
  let params = buildParams();
  getOrderOrders(params).then(res=>{
    if (res.Code === 0) {
      // 为每个订单计算备注
      res.Data = res.Data.map((order) => ({
        ...order,
        Summary: calculateSummary(order.Stages),
      }));
      orders.value = res.Data;
      total.value = res.Total;
    }
  }).catch(err=>{
    console.log(err);
  })

};

// 显示订单详情
const showOrderDetail = (order) => {
  currentOrder.value = order.Stages;
  currentBillNo.value = order.BillNo;
  selectID.value = order.ID;
  dialogVisible.value = true;
};

// 显示采购详情
const showPODetail = (po_order) => {
  currentPOOrder.value = po_order.MaterialList;
  currentBillNo.value = po_order.BillNo;
  dialogPOVisible.value = true;
};


// 处理编辑按钮点击
const handleEdit = (row) => {
  // 保存原始数据以便取消时恢复
  row.originalData = { ...row };
  row.isEditing = true;
};

// 计算备注内容
const calculateSummary = (stages) => {
  if (!stages || stages.length === 0) return "";

  // 按照优先级筛选需要显示的状态
  const priorityStatus = stages
    .filter((stage) => {
      // 筛选异常、缺料、未领料等需要特别关注的状态
      return (
        stage.Status === "异常" ||
        stage.Status === "缺料" ||
        stage.Status === "待确认" ||
        stage.Status === "未领料" ||
        stage.Status === "未排产" ||
        stage.Status === "部分领料" ||
        (stage.StageId === 3 && stage.Status !== "完工")
      ); // 生产状态非完工的情况
    })
    .map((stage) => `${stage.StageName}:${stage.Status}`);

  return priorityStatus.join("; ");
};

// 处理保存按钮点击
const handleSave = async (row) => {
  try {
    http.put(`/order/orders/stage/${row.Id}`, row).then(res=>{
      if (res.Code === 0) {
        // 更新成功
        row.isEditing = false;
        ElMessage({
          type: "success",
          message: "保存成功",
        });
        getOrderData();
      }else {
        ElMessage({
          type: "error",
          message: "保存失败",
        })
      }
    }).catch(err=>{
      console.error("保存失败:", err);
      ElMessage({
        type: "error",
        message: "保存失败",
      })
    });

  }catch (err){
    console.error("保存失败:", err);
  }
};

// 处理取消按钮点击
const handleCancel = (row) => {
  // 恢复原始数据
  Object.assign(row, row.originalData);
  row.isEditing = false;
  delete row.originalData;
};

// 添加跟进记录

// const toggleFavorite = async (item) => {
//   try {
//     http.put(`/api/orders/notice/${item.ID}`).then(res=>{
//       if (res && res.Code === 0) {
//         // 直接更新当前项的收藏状态
//         item.IsFav = res.IsFav;
//         // 重新获取订单数量统计
//         fetchStatData(dateRange.value[0], dateRange.value[1]);
//         ElMessage.success(res.Msg);
//       }
//     }).catch(err=>{
//       console.log(err)
//     })
//   } catch (error) {
//     ElMessage.error("操作失败");
//   }
// };


const getDiffDay = (date_str,ext=0) => {
  if (!date_str) return "-";
  let current_time = dayjs();
  let delivery_date = dayjs(date_str, "YYYY-MM-DD hh:mm:ss");
  return delivery_date.diff(current_time, "day")+ext;
};

const formatDate = (row, column, cellValue) => {
  if (cellValue) {
    // 检查 cellValue 是否为 Date 对象
    if (cellValue instanceof Date) {
      return dayjs(cellValue).format("YYYY-MM-DD");
    }
    // 假设 cellValue 是字符串
    return cellValue.slice(0, 10);
  }
  return "-";
};

// 添加卡片点击处理方法
const handleCardClick = (item) => {
  currentPage.value = 1;
  activeCard.value = item.notice_code;
  getOrderData();
};
const handleSortChange = ({ column, order }) => {
  const sortOrder = order;
  const columnName = column.property;
  if (sortOrder === "descending") {
    OrderBy.value = "-" + columnName;
  } else {
    OrderBy.value = columnName;
  }
  getOrderData();
};
const handleCurrentChange = (val) => {
  currentPage.value = val;
  getOrderData();
};
const handleSizeChange = (val) => {
  pageSize.value = val;
  getOrderData();
};

const tableRowClassName = ({ row, rowIndex }) => {
  console.log('row index', rowIndex, 'row value', row.Diff)
  if (row.Diff > 0) {
    return "warning-row";
  }
  return "";
};

// 在 script setup 部分添加
const activeCard = ref(11); // 用于跟踪当前选中的卡片
onMounted(() => {
  // 组件挂载时使用默认时间范围获取数据
  // handleDateChange(dateRange.value);
  getOrderData();
  fetchStatData(dateRange.value[0], dateRange.value[1]);
  //getCurrentUser();
  tableHeight.value = window.innerHeight - 300
});

// 打开产品查询页面
const openProductSearch = () => {
  router.push({"path":'/product'});
};

// 打开生产计划查看页面
const openProduceView = () => {
  router.push({"path":'/produce'});
};

// 处理表格选择变化
const handleSelectionChange = (selection) => {
  selectedOrders.value = selection;
};

// 处理批量删除
const handleBatchDelete = () => {
  ElMessageBox.confirm(
    `删除后不再显示在看板上，确认删除选中的 ${selectedOrders.value.length} 条记录吗？`,
    "提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  ).then(async () => {
    try {
      // 获取所有选中订单的 ID
      const order_ids = selectedOrders.value.map((order) => order.ID);
      // 发送批量删除请求
      deleteOrderOrders( {data: { order_ids }}).then(res=>{
        if (res.Code === 0) {
          ElMessage({
            type: "success",
            message: "删除成功",
          });
          // 刷新数据
          getOrderData();
        }
      }).catch (error=>{
        console.error("删除失败:", error);
        ElMessage({
          type: "error",
          message: "删除失败",
        });
      })
    }catch (e) {
      console.error("删除失败:", e);
    }
  });
};

// 添加导出Excel的逻辑
const exportToExcel = async () => {
  // 定义字段映射
  const fieldMap = {
    BillNo: "销售编码",
    Progress: "进度",
    Summary: "备注",
    MaterialName: "成品名称",
    MaterialNumber: "物料编码",
    Qty: "下单数量",
    ProduceQty: "生产数量",
    StockInQuaAuxQty: "入库数量",
    DeliveryDate: "要货时间",
    PlanStartDate: "排产时间",
    Saler: "销售人",
    BillCreateTime: "下单时间",
    PlanEndDate: "排产结束时间",
    ProduceStatus: "生产状态",
    MaterialStatus: "领料状态",
    BomName: "Bom版本",
    Specification: "Specification",
  };
  currentPage.value = 0;
  pageSize.value = 10000
  let params = buildParams();
  const order_ids = selectedOrders.value.map((order) => order.ID);
  params.SelectData = order_ids.join(',')
  getOrderOrders(params).then(res=>{
    if (res.Code === 0) {
      // 移除 IsFav 字段并重命名其他字段
      const dataToExport = res.Data.map((order) => {
        const { ...rest } = order;
        const renamedOrder = {};
        for (const key in rest) {
          if (fieldMap[key]) {
            renamedOrder[fieldMap[key]] = rest[key];
          }
        }
        return renamedOrder;
      });

      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "订单数据");
      let tmp_today = dayjs().format("YYYY-MM-DD");
      XLSX.writeFile(workbook, `销售订单_${tmp_today}.xlsx`);
    }
  }).catch(err=>{
    console.log(err);
  })

};

// 显示帮助抽屉
const showHelp = () => {
  helpDrawerVisible.value = true;
};
</script>

<style scoped>
.dashboard-container {
  padding: 20px 25px;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  max-height: 100vh;
}

.el-dialog__body {
  padding: 0 !important;
}

/* 卡片样式优化 */
:deep(.el-card) {
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  transition: all 0.3s;
}

:deep(.el-card:hover) {
  box-shadow: 0 4px 12px rgba(0, 21, 41, 0.12);
}

:deep(.el-card__header) {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
  background-color: #fafafa;
}

/* 统计卡片样式 */
.stats-cards {
  margin-bottom: 5px;
}

.stats-card {
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  min-width: 220px;
  padding: 10px 0;
}

.stats-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stats-card.is-active {
  border-color: #409eff;
  background-color: rgba(64, 158, 255, 0.05);

  .number {
    color: #409eff;
  }

  .item-title {
    color: #409eff;
    font-weight: 600;
  }
}

.stats-card .card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
}

.stats-card .number {
  font-size: 28px;
  font-weight: 600;
  color: #606266;
  margin: 0 0 8px 0;
  line-height: 1;
  transition: color 0.3s;
}

.stats-card .item-title {
  margin: 0;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
  transition: all 0.3s;
}

/* 订单卡片样式 */
.order-card {
  margin-bottom: 16px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  /* 选中状态样式 */
  &.is-selected {
    box-shadow: 0 0 0 2px var(--el-color-primary);
    background-color: var(--el-color-primary-light-9);

    /* 根据状态调整选中时的阴影颜色 */
    &.status-normal {
      box-shadow: 0 0 0 2px var(--el-color-success);
    }

    &.status-error {
      box-shadow: 0 0 0 2px var(--el-color-danger);
    }

    &.status-pending {
      box-shadow: 0 0 0 2px var(--el-color-warning);
    }

    &.status-expired {
      box-shadow: 0 0 0 2px var(--el-color-info);
    }
  }

  /* 其他状态样式保持不变 */
  &.status-normal {
    border-left-color: var(--el-color-success);
  }

  &.status-error {
    border-left-color: var(--el-color-danger);
  }

  &.status-pending {
    border-left-color: var(--el-color-warning);
  }

  &.status-expired {
    border-left-color: var(--el-color-info);
  }
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.order-no {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.order-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: nowrap;
}

.order-actions :deep(.el-tag) {
  white-space: nowrap;
  cursor: pointer;
}

.order-info {
  margin: 8px 0;
  color: #606266;
  line-height: 1.6;
}

.order-info .label {
  color: #909399;
  margin-right: 8px;
}

/* 表单样式优化 */
:deep(.el-form-item__label) {
  font-weight: 500;
  color: #606266;
}

:deep(.el-input__wrapper),
:deep(.el-textarea__inner) {
  box-shadow: 0 0 0 1px #dcdfe6 inset;
  transition: all 0.3s;
}

:deep(.el-input__wrapper:hover),
:deep(.el-textarea__inner:hover) {
  box-shadow: 0 0 0 1px #c0c4cc inset;
}

:deep(.el-input__wrapper.is-focus),
:deep(.el-textarea__inner:focus) {
  box-shadow: 0 0 0 1px #409eff inset;
}

/* 评论区样式优化 */
.comments-list {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
}

.comment-item {
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
}

.comment-item:hover {
  background-color: #f0f2f5;
  transform: translateX(4px);
}

.comment-item:last-child {
  margin-bottom: 0;
  border-bottom: none;
}

.comment-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.comment-avatar {
  background-color: #409eff;
  color: #fff;
  font-weight: 600;
}

.comment-author {
  font-weight: 600;
  color: #303133;
  font-size: 14px;
}

.comment-time {
  color: #909399;
  font-size: 12px;
  margin-left: auto;
}

.comment-content {
  color: #606266;
  line-height: 1.8;
  font-size: 14px;
  padding: 0 4px;
}

.add-comment {
  padding: 20px 0 20px 0;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.04);
}

.add-comment :deep(.el-textarea__inner) {
  padding: 12px;
  font-size: 14px;
  border-radius: 4px;
  resize: none;
  background-color: #f8f9fa;
  border: none;
  transition: all 0.3s;
}

.add-comment :deep(.el-textarea__inner:focus) {
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.add-comment :deep(.el-button) {
  margin-top: 16px;
  height: 40px;
  font-size: 14px;
  letter-spacing: 1px;
  transition: all 0.3s;
}

.add-comment :deep(.el-button:hover) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}

/* 自定义滚动条样式 */
.comments-list::-webkit-scrollbar {
  width: 6px;
}

.comments-list::-webkit-scrollbar-thumb {
  background-color: #dcdfe6;
  border-radius: 3px;
}

.comments-list::-webkit-scrollbar-track {
  background-color: #f8f9fa;
}

/* 标签样式 */
:deep(.el-tag) {
  border-radius: 4px;
  padding: 0 8px;
  height: 24px;
  line-height: 22px;
}

/* 按钮样式 */
:deep(.el-button) {
  padding: 8px 20px;
  font-weight: 500;
  border-radius: 4px;
}

/* 抽屉样式 */
:deep(.el-drawer__header) {
  margin-bottom: 0;
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}

:deep(.el-drawer__body) {
  padding: 20px;
}

/* 对话框样式 */
:deep(.el-dialog__header) {
  padding: 20px;
  margin-right: 0;
  border-bottom: 1px solid #ebeef5;
}

:deep(.el-dialog__body) {
  padding: 24px;
}

:deep(.el-dialog__footer) {
  padding: 16px 20px;
  border-top: 1px solid #ebeef5;
}

/* 用户信息样式 */
.header-user-info {
  position: absolute;
  top: 30px;
  right: 40px;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.user-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
}

.user-wrapper:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.username {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

/* 消息样式 */
.message-badge {
  margin-right: 8px;
}

.message-list {
  padding: 16px;
}

.message-item {
  padding: 16px;
  border-bottom: 1px solid #ebeef5;
  transition: background-color 0.3s;
}

.message-item:hover {
  background-color: #f5f7fa;
}

.message-title {
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.message-content {
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 8px;
}

.message-time {
  color: #909399;
  font-size: 12px;
}

.notice-count {
  margin-left: 8px;
}

.is-favorite {
  color: #f7ba2a;
}

.show-detail {
  cursor: pointer;
}

.po-detail-tooltip {
  cursor: pointer;
  color: #409eff;
}

.main-title {
  width: 100%;
  margin: 0 auto;
}

/* 订单详情对话框样式 */
:deep(.el-dialog) {
  border-radius: 8px;
  box-shadow: 0 12px 32px 4px rgba(0, 0, 0, 0.04),
    0 8px 20px rgba(0, 0, 0, 0.08);
}

:deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.order-detail {
  padding: 0;
}

/* 详情表格样式 */
.order-detail :deep(.el-table) {
  width: 100%;
  border: none;
  margin: 0;
}

.order-detail :deep(.el-table__header) {
  background-color: #f5f7fa;
}

.order-detail :deep(.el-table__header th) {
  background-color: #f5f7fa;
  padding: 12px;
  height: 48px;
  font-weight: 600;
  text-align: left;
}

.order-detail :deep(.el-table__body td) {
  padding: 12px;
  height: 48px;
  text-align: left;
}

.order-detail :deep(.el-table__cell) {
  padding: 12px !important;
}

.order-detail :deep(.el-table .cell) {
  padding: 0;
  line-height: 23px;
}

/* 阶段标题样式 */
.stage-title {
  margin: 24px 0 16px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 8px;
}

.stage-title::before {
  content: "";
  width: 4px;
  height: 16px;
  background-color: #409eff;
  border-radius: 2px;
}

/* 状态标签样式 */
.order-detail :deep(.el-tag) {
  border-radius: 4px;
  padding: 0 12px;
  height: 28px;
  line-height: 26px;
  font-weight: 500;
}

/* 可点击文本样式 */
.po-detail-tooltip {
  cursor: pointer;
  color: #409eff;
  transition: all 0.3s;
  padding: 2px 4px;
  border-radius: 4px;
}

.po-detail-tooltip:hover {
  background-color: rgba(64, 158, 255, 0.1);
  text-decoration: underline;
}

/* 分隔线样式 */
.detail-divider {
  margin: 24px 0;
  border-top: 1px solid #ebeef5;
}

/* 详情内容布局 */
.detail-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* 详情项样式 */
.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  line-height: 1.6;
}

.detail-label {
  color: #909399;
  min-width: 80px;
}

.detail-value {
  color: #303133;
  flex: 1;
}

/* 空状态样式 */
.empty-content {
  text-align: center;
  padding: 32px;
  color: #909399;
}

/* 详情页脚样式 */
:deep(.el-dialog__footer) {
  background-color: #f8f9fa;
  border-radius: 0 0 8px 8px;
}

:deep(.el-dialog__footer .el-button) {
  min-width: 100px;
}

.follow-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  padding: 20px 20px 20px 0;
  margin-right: 0;
  border-bottom: 1px solid #ebeef5;
}

.no-padding {
  padding: 0 !important;
  text-align: left;
}

.filter-section {
  margin-bottom: 15px;
}

.order-list {

}

/* 表格样式优化 */
:deep(.el-table) {
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  transition: all 0.3s;
  flex: 1;
  height: 100% !important;
  /* 覆盖内联样式 */
  table-layout: fixed;
}

:deep(.el-table:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

:deep(.el-table__header-wrapper) {
  background-color: #f5f7fa;
}

:deep(.el-table__header th) {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
  height: 48px;
}

:deep(.el-table__row) {
  transition: all 0.3s;
}

:deep(.el-table__row:hover) {
  background-color: #f5f7fa;
}

:deep(.el-table__row td) {
  padding: 12px 0;
}

:deep(.el-tag) {
  border-radius: 4px;
  padding: 0 8px;
  height: 24px;
  line-height: 22px;
  font-weight: 500;
  cursor: pointer;
}

/* 分页器样式 */
:deep(.el-pagination) {
  padding: 20px 0;
  background: white;
  border-top: 1px solid #ebeef5;
  margin-top: auto;
  /* 确保分页器在底部 */
}

/* 优化分页器在小屏幕上的显示 */
@media screen and (max-width: 768px) {
  :deep(.el-pagination) {
    .el-pagination__sizes {
      display: none;
    }
  }
}

.page-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
}

.el-card {
  --el-card-padding: 5px !important;
}

/* 添加编辑状态的样式 */
.order-detail :deep(.el-input--small) {
  width: 100%;
}

.order-detail :deep(.el-select--small) {
  width: 100%;
}

.order-detail :deep(.el-date-picker--small) {
  width: 100%;
}

/* 调整按钮间距 */
.order-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

/* 优化文本域样式 */
.order-detail :deep(.el-textarea__inner) {
  padding: 8px;
  min-height: 60px;
}

.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}

/* 按钮组样式 */
.el-col:last-child {
  display: flex;
  gap: 8px;
}

.el-button {
  white-space: nowrap;
}

/* 批量操作工具栏样式 */
.batch-actions {
  padding: 8px 16px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  transition: all 0.3s;
}

/* 调整表格上边距 */
.el-table {
  margin-top: 8px;
}

/* 帮助按钮样式 */
.help-button {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 帮助内容样式 */
.help-content {
  padding: 1px;
  text-align: left;

  h3 {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin: 20px 0 12px;
    position: relative;
    padding-left: 10px;
    text-align: left;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 14px;
      background-color: #409eff;
      border-radius: 2px;
    }

    &:first-child {
      margin-top: 0;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0 0 16px;
    text-align: left;

    &:last-child {
      margin-bottom: 0;
    }

    li {
      margin-bottom: 12px;
      background: #f8f9fa;
      border-radius: 6px;
      padding: 0 0 12px 12px;
      transition: all 0.3s ease;
      text-align: left;

      &:hover {
        background: #f0f2f5;
        transform: translateX(4px);
      }

      &:last-child {
        margin-bottom: 0;
      }

      strong {
        display: block;
        color: #409eff;
        font-size: 14px;
        margin-bottom: 4px;
        text-align: left;
      }

      p {
        color: #606266;
        margin: 0;
        line-height: 1.5;
        font-size: 13px;
        text-align: left;
      }
    }
  }
}
</style>
